import React from 'react'
import PropTypes from 'prop-types'
import Table from '../../../../shared/settings/async-table'
import styles from './recurring-vouchers.css'

const getTdProps = () => ({ className: styles.vouchersTableData })
const getTheadThProps = () => ({ className: styles.vouchersTableHeaderData })
const getTheadProps = () => ({ className: styles.vouchersTableHeader })
const getTrGroupProps = () => ({ className: styles.vouchersTableGroup })
const getTbodyProps = () => ({ className: styles.vouchersTableBody })

export const DesktopTable = ({
  className,
  tableColumns,
  vouchers
}) => {
  return (
    <Table
      className={className}
      columns={tableColumns}
      data={vouchers}
      showPagination={false}
      getTdProps={getTdProps}
      getTheadThProps={getTheadThProps}
      getTheadProps={getTheadProps}
      getTrGroupProps={getTrGroupProps}
      getTbodyProps={getTbodyProps}
    />
  )
}

DesktopTable.propTypes = {
  className: PropTypes.string.isRequired,
  tableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      Cell: PropTypes.func.isRequired,
      Header: PropTypes.string.isRequired,
      accessor: PropTypes.string,
      id: PropTypes.string.isRequired,
      minWidth: PropTypes.number
    })
  ).isRequired,
  vouchers: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired
    })
  ).isRequired
}
